import React, { useState } from "react";
import {
  FiArrowLeft,
  FiUsers,
  FiMapPin,
} from "react-icons/fi";
import authAxios from "../../../api/authAxios";
import SitesTab from "../OrgAdminView/SitesTab";  // ✅ using your updated version
import UsersTab from "../OrgAdminView/UsersTab";  // assuming you have this already

export default function OrganizationDetail({
  org: initialOrg,
  onBack,
  onSelectSite,
  onAddUser,
  onEditUser,
  onDeleteUser,
  onAddSite,
  onEditSite,
  onDeleteSite,
}) {
  const [org, setOrg] = useState(initialOrg);
  const [activeTab, setActiveTab] = useState("sites");
  const [isRefreshing, setIsRefreshing] = useState(false);

  // ✅ Fetch the latest org data (after add/edit/delete)
  const fetchOrg = async () => {
    try {
      setIsRefreshing(true);
      const res = await authAxios.get(`/organizations/${org.id}/`);
      setOrg(res.data);
    } catch (err) {
      console.error("Error refreshing org:", err);
    } finally {
      setIsRefreshing(false);
    }
  };

  const tabs = [
    { key: "sites", label: "Sites", icon: <FiMapPin /> },
    { key: "users", label: "Users", icon: <FiUsers /> },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
          >
            <FiArrowLeft /> Back
          </button>
          <h1 className="text-2xl font-bold">{org.name}</h1>
          {isRefreshing && (
            <span className="text-sm text-gray-500">(Refreshing…)</span>
          )}
        </div>

        <div className="flex gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition ${
                activeTab === tab.key
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-blue-500/20"
              }`}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tabs */}
      {activeTab === "sites" && (
        <SitesTab
          org={org}
	  currentUser={{ global_role: "platform_admin" }}
          onSelectSite={onSelectSite}
          onAddSite={async (...args) => {
            await onAddSite(...args);
            await fetchOrg();
          }}
          onEditSite={async (...args) => {
            await onEditSite(...args);
            await fetchOrg();
          }}
          onDeleteSite={async (...args) => {
            await onDeleteSite(...args);
            await fetchOrg();
          }}
        />
      )}

      {activeTab === "users" && (
        <UsersTab
          org={org}
	  currentUser={{ global_role: "platform_admin" }}
          onAddUser={async (...args) => {
            await onAddUser(...args);
            await fetchOrg();
          }}
          onEditUser={async (...args) => {
            await onEditUser(...args);
            await fetchOrg();
          }}
          onDeleteUser={async (...args) => {
            await onDeleteUser(...args);
            await fetchOrg();
          }}
        />
      )}
    </div>
  );
}

